<script setup lang="ts">
/**
 * The badge naming what the AI wrote: a conclusion it drafted, a row of the
 * intervention table it proposed.
 *
 * The source is named wherever it appears, and it appears the same way
 * everywhere: the pharmacist should recognise at a glance what they are
 * reading before they sign it (ADR 0004). The badge goes the moment they
 * change a word — whoever shows it decides that, not the badge.
 */
import {Sparkles} from "@lucide/vue";
import {CHIP} from "@/medication-checkup/services/SceneClasses";

defineProps<{
    /**
     * What the tooltip warns of, where the proposal deserves a second read.
     */
    title?: string;
}>();
</script>

<template>
  <span
    :class="CHIP"
    class="gap-1 bg-lightPurple-lightest text-primary"
    :title="title"
  >
    <Sparkles class="w-3 h-3" />
    Pré-rempli par l'IA
  </span>
</template>
